import React, { useState, useEffect } from 'react';
import { Routes, Route, Navigate, useNavigate, useLocation, Outlet } from 'react-router-dom';
import { Layout, ConfigProvider } from 'antd';
import zhCN from 'antd/lib/locale/zh_CN';

// 导入页面组件
import Login from './pages/Login';
import Home from './pages/Home';
import Admin from './pages/Admin';
import Submit from './pages/Submit';
import Query from './pages/Query';
import Customers from './pages/Customers';
import Logs from './pages/Logs';
import Share from './pages/Share';
import WxPusherConfig from './pages/WxPusherConfig';
import WxPusherTemplates from './pages/WxPusherTemplates';
import EditShipment from './pages/EditShipment';
import NotFound from './pages/NotFound';

// 导入样板系统页面
import PatternManagement from './pages/PatternManagement';
import PatternCategories from './pages/PatternCategories';
import PatternSearch from './pages/PatternSearch';

// 导入上下文
import { AuthProvider } from './contexts/AuthContext';

// 导入组件
import AppHeader from './components/AppHeader';
import ProtectedRoute from './components/ProtectedRoute';

const { Content, Footer } = Layout;

function App() {
  const [locale, setLocale] = useState(zhCN);
  
  return (
    <ConfigProvider locale={locale}>
      <AuthProvider>
        <Layout style={{ minHeight: '100vh' }}>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/share/:id" element={<Share />} />
            
            {/* 使用布局路由模式 */}
            <Route path="/" element={
              <ProtectedRoute>
                <Layout>
                  <AppHeader />
                  <Content className="container">
                    <Outlet />
                  </Content>
                  <Footer style={{ textAlign: 'center' }}>
                    仓库管理系统 ©{new Date().getFullYear()} Created with React
                  </Footer>
                </Layout>
              </ProtectedRoute>
            }>
              <Route index element={<Home />} />
              <Route path="admin" element={<Admin />} />
              <Route path="submit" element={<Submit />} />
              <Route path="query" element={<Query />} />
              <Route path="edit/:shipmentId" element={<EditShipment />} />
              <Route path="customers" element={<Customers />} />
              <Route path="logs" element={<Logs />} />
              <Route path="wx-pusher" element={<WxPusherConfig />} />
              <Route path="wx-templates" element={<WxPusherTemplates />} />
              
              {/* 样板系统路由 */}
              <Route path="pattern-management" element={<PatternManagement />} />
              <Route path="pattern-categories" element={<PatternCategories />} />
              <Route path="pattern-search" element={<PatternSearch />} />
            </Route>
            
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Layout>
      </AuthProvider>
    </ConfigProvider>
  );
}

export default App;
